module.exports = __webpack_public_path__ + "img/instagram.4b96cb79.svg";